import { render, staticRenderFns } from "./DialogPlanoCliente.vue?vue&type=template&id=dd7dd836&"
import script from "./DialogPlanoCliente.vue?vue&type=script&lang=js&"
export * from "./DialogPlanoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports